// @module Tavanoteam.ProductSpecifications.Documents
define('Tavanoteam.ProductSpecifications.Documents.View'
	, [
		"Documents.Model"

		, 'tavanoteam_productspecifications_documents.tpl'

		, 'Backbone'
	]
	, function (
		DocumentsModel

		, tavanoteam_productspecifications_documents_tpl

		, Backbone
	) {
		'use strict';

		// @class Tavanoteam.ProductSpecifications.Documents.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_productspecifications_documents_tpl

			, initialize: function (options) {
				this.pdpComponent = options.container.getComponent('PDP');
				this.environmentComponent = options.container.getComponent('Environment');

				this.model = new DocumentsModel();

				var self = this;

				this.pdpComponent.on('afterShowContent', function () {
					self.fetchItemSpecification();
				});
			}

			, fetchItemSpecification: function () {
				var self = this;
				var item = this.pdpComponent.getItemInfo().item,
					itemId = item.internalid,
					itemDocuments = item.custitem_item_documents;

				if (!!itemDocuments) {
					this.model.fetch({ data: { itemId: itemId } }).done(function (result) {
						self.documents = result[1];

						self.render();
					});
				}
			}

			//@method getContext @return Tavanoteam.ProductSpecifications.Documents.View.Context
			, getContext: function getContext() {
				//@class Tavanoteam.ProductSpecifications.Documents.View.Context

				return {
					domain: this.environmentComponent.getSiteSetting('touchpoints').home,
					documents: this.documents
				};
			}
		});
	});
